import { getBasePositionSet, getBaseSignature } from "selectors/base"
import { Creators as ProfileCreators } from "model/profileModal"
import { getViewType, getSelectedModelId, getMustAggregateFactors, getCurrency } from "modules/portfolio-root/selectors/portfolios"
import createModule from "../createModule"
import view from "./view"
import { getDetails, getTopTotal } from "./selectors/details"
import { VIEW_TYPES } from "helpers/base"
import { MODEL_METADATA_QUERY } from "resources/models"

export default createModule({
  view,
  externalProps: (state) => ({
    account: state.global.selected.account,
    portfolioId: state.global.selected.portfolio,
    modelId: getSelectedModelId(state),
    base: getBasePositionSet(state),
    baseSignature: getBaseSignature(state),
    viewType: getViewType(state),
    hasAggregatedFactors: getMustAggregateFactors(state),
    currency: getCurrency(state),
  }),
  required: ["account", "portfolioId", "modelId"],
  data: [{
    resource: "factorVolatility",
    as: null,
    url: ({ modelId, date, hasAggregatedFactors, currency }) => {
      if (hasAggregatedFactors) {
        return null
      }
      return {
        id: `${modelId}${date}${currency}`,
        query: `query ($modelId: String!, $date: Date!, $currency: Currency) {
        model (id: $modelId) {
          factors(currency: $currency) {
            id
            covariance (on: $date) {
              factors { id, annualizedPercentSquared }
            }
          }
        }
      }`,
        variables: {
          modelId,
          date,
          currency,
        },
      }
    },
  }, {
    resource: "riskDetails",
    as: null,
    passthrough: true,
    url: ({ modelId, portfolioId, date, base, baseSignature, viewType, currency }) => ({
      id: `${modelId}${portfolioId}${date}${viewType}${baseSignature}${currency}`,
      query: `query ($modelId: String!, $on: Date!, $positionSet: PositionSetInput!, $base: [PositionSetInput]) {
        model (id: $modelId) {
          simulation(positionSet: $positionSet, from: $on, to: $on, base: $base) {
            exposure {
              factors {
                id
                net
                long
                short
                category
              }
            }
          }
        }
      }`,
      variables: {
        modelId,
        positionSet: {
          type: "PORTFOLIO",
          id: portfolioId,
        },
        base: viewType === VIEW_TYPES.ACTIVE ? [base] : undefined,
        on: date,
      },
    }),
  },
  MODEL_METADATA_QUERY,
  ],
  mapStateToProps: (state, props) => ({
    riskDetails: getDetails(state, props),
    max: getTopTotal(state, props),
  }),
  actions: {
    openFactorProfile: ProfileCreators.openFactorProfile,
  },
})
